export enum DataFeedClient {
  Web = 'web',
  Mobile = 'mobile',
}

export enum DataFeedEngine {
  Cfd = 'cfd',
  Crypto = 'crypto',
}

export type DataFeedHosts = Record<DataFeedClient, Record<DataFeedEngine, string | undefined>>;

export interface IEnvService {
  isDevelopmentMode: boolean;
  isProductionMode: boolean;
  environment: Window['ENVIRONMENT'] | 'unknown';
  dataFeedHosts: DataFeedHosts;
}
